/**
 * 组织接口秘钥实体
 */

import { useState } from 'react';
import {
    Flex,
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '组织秘钥';

const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [serviceCode, setServiceCode] = useState(null);
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setServiceCode(null);
        setDescription('');
    };


    const ok = () => {
        if (serviceCode === null) {
            messageApi.error('服务代码不能为空！');
            return;
        }

        if (!description) {
            messageApi.error('备注说明不能为空！');
            return;
        }

        setLoading(true);
        $.ajax({
            url: `${CNF.api}orgs/apikeys`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                service_code: serviceCode,
                description: description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false);
        }, CNF.messageDuration * 1000))
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={500}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>服务代码</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Select
                                placeholder='请选择'
                                value={serviceCode}
                                style={{ width: '100%' }}
                                onChange={(value) => setServiceCode(value ?? '')}
                                disabled={loading}
                                options={(props.serviceCodes || []).map(item => ({
                                    value: item,
                                    label: item,
                                    key: item
                                }))}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>备注说明</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                onChange={(e) => setDescription(e.target.value)}
                                value={description}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity